import React from "react";
import { Switch, Route } from "react-router-dom";

// core components
import HipposFixedPlugin from "../components/FixedPlugin/HipposFixedPlugin";

// dynamically create dashboard routes
import hipposRoutes from "../hipposRoutes.js";

import image3 from "assets/img/full-screen-image-3.jpg";
import HipposSidebar from "../components/Sidebar/HipposSidebar";
import HipposAdminNavbar from "../components/Navbars/HipposAdminNavbar.js";
import HipposAdminFooter from "../components/Footers/HipposAdminFooter.js";
import { useHistory } from "react-router-dom";
import { apiService } from "../service/ApiService";
import NotificationAlert from "react-notification-alert";
import { notificationService } from "../service/NotificationService";
import { useTranslation } from "react-i18next";

function HipposAdmin() {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.resolvedLanguage || i18n.language;
  const notificationAlertRef = React.useRef(null);
  notificationService.registerRef(notificationAlertRef);
  const history = useHistory();

  const [sidebarImage, setSidebarImage] = React.useState(image3);
  const [sidebarBackground, setSidebarBackground] = React.useState("black");
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/admin") {
        return <Route path={prop.layout + prop.path} key={key} component={prop.component} />;
      } else {
        return null;
      }
    });
  };
  const getSidebarRoutes = (routes) => {
    return routes.filter(
      (item) =>
        (!item.hasOwnProperty("hideInSidebar") || item["hideInSidebar"] === false) && item.accessLevel <= parseInt(apiService.getAccessLevel())
    );
  };
  return (
    <>
      <div className="wrapper">
        <HipposSidebar routes={getSidebarRoutes(hipposRoutes)} image={sidebarImage} background={sidebarBackground} />
        <div className="main-panel">
          <HipposAdminNavbar />
          <div className="content">
            <div className="rna-container">
              <NotificationAlert ref={notificationAlertRef} />
            </div>
            <Switch key={currentLanguage}>{getRoutes(hipposRoutes)}</Switch>
          </div>
          <HipposAdminFooter />
          <div className="close-layer" onClick={() => document.documentElement.classList.toggle("nav-open")} />
        </div>
      </div>
      <HipposFixedPlugin />
    </>
  );
}

export default HipposAdmin;
